export default __webpack_public_path__ + "static/media/no-savings-report.57780829.png";